import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { ThunderboltFilled, ClockCircleOutlined } from '@ant-design/icons';
import { INSTANT_DELIVERY_LABEL, STANDARD_DELIVERY_LABEL } from '../advanceSummaryCard.constants';
import styles from '../styles/advanceSummaryCard.module.scss';

const TILE_ICON_STYLE = { fontSize: 16 };

function Tile({ icon, title, sub, value, highlighted = false }) {
    const tileClass = `${styles.tile} ${highlighted ? styles.tileHighlighted : ''}`.trim();
    const iconClass = `${styles.tileIcon} ${highlighted ? styles.tileIconHighlighted : ''}`.trim();
    const valueClass = `${styles.tileValue} ${highlighted ? styles.tileValueHighlighted : ''}`.trim();
    const styledIcon = React.cloneElement(icon, { style: { ...(icon.props.style || {}), ...TILE_ICON_STYLE } });
    return (
        <div className={tileClass}>
            <div className={styles.tileHeader}>
                <span className={iconClass} aria-hidden="true">
                    {styledIcon}
                </span>
                <div className={styles.tileText}>
                    <Text as="span" size="xs" className={styles.tileTitle}>
                        {title}
                    </Text>
                    <Text as="span" size="xs" className={styles.tileSub}>
                        {sub}
                    </Text>
                </div>
            </div>
            <Text as="span" size="s" className={valueClass}>
                {value}
            </Text>
        </div>
    );
}

function DeliveryTiersStrip({ instantFee, standardLabel }) {
    const instantFeeLabel = `$${(Number(instantFee) || 0).toFixed(2)}`;
    return (
        <div className={styles.deliveryTiers}>
            <Tile
                icon={<ThunderboltFilled />}
                title="Instant"
                sub={INSTANT_DELIVERY_LABEL}
                value={instantFeeLabel}
                highlighted
            />
            <Tile
                icon={<ClockCircleOutlined />}
                title="Standard"
                sub={standardLabel || STANDARD_DELIVERY_LABEL}
                value="Free"
            />
        </div>
    );
}

export default DeliveryTiersStrip;
